export default __webpack_public_path__ + "static/media/b_wdt_c_0_1.4e917070.mp3";